import React, {useEffect} from 'react';
import profileImage from '../assets/Home/profileImg.jpg';
import mysql from '../assets/Home/mysql-icon.svg';
import html from '../assets/Home/html5-original-wordmark.svg';
import css from '../assets/Home/css3-original-wordmark.svg';
import javaScript from '../assets/Home/javascript-original.svg';
import git from '../assets/Home/git-scm-icon.svg';
import node from '../assets/Home/nodejs-original-wordmark.svg';
import typescript from '../assets/Home/typescript-icon.svg';
import netlify from '../assets/Home/netlify-icon.svg';
import goLang from '../assets/Home/go-original.svg';
import mongoDB from '../assets/Home/mongodb-original-wordmark.svg';
import react from '../assets/Home/react.svg';
import getPostman from '../assets/Home/postman-icon-svgrepo-com.svg';
import '../pages/Home.css';

export default function Home() {
    
    useEffect(() => {
        document.title='Home';
    })
    
    return (
        <div className='Home'>
            <main className='Home-main'>
                <img src={profileImage} className="Home-profile-image" alt="profile" />
                <h1>
                    Jesus Porras
                </h1>
                <p>
                    Fluent in English, but more importantly, over 14 programming tools
                </p>
                <span>
                    Ready to make a difference?
                </span>
                <a href="/about">Meet Me</a>
                <div className='Home-hero-container'>
                    <h3>Languages and Tools</h3>
                    <div className='Home-stack-container'>
                        <img src={mysql} className="Home-icon-image" alt="mysql" />
                        <img src={html} className="Home-icon-image" alt="html" />
                        <img src={css} className="Home-icon-image" alt="css" />
                        <img src={javaScript} className="Home-icon-image" alt="javascript" />
                        <img src={react} className="Home-icon-image" alt="react" />
                        <img src={typescript} className="Home-icon-image" alt="typescript" />
                        <img src={git} className="Home-icon-image" alt="git" />
                        <img src={node} className="Home-icon-image" alt="node" />
                        <img src={netlify} className="Home-icon-image" alt="netlify" />
                        <img src={goLang} className="Home-icon-image" alt="goLang" />
                        <img src={mongoDB} className="Home-icon-image" alt="mongoDB" />
                        <img src={getPostman} className="Home-icon-image" alt="get postman" />
                    </div>
                </div>
            </main>
        </div>
    )
}